import { render } from "./HotPointComponentAI.vue?vue&type=template&id=d623b6aa&scoped=true"
import script from "./HotPointComponentAI.vue?vue&type=script&lang=js"
export * from "./HotPointComponentAI.vue?vue&type=script&lang=js"

import "./HotPointComponentAI.vue?vue&type=style&index=0&id=d623b6aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d623b6aa"]])

export default __exports__